import type ApiRequestError from 'src/core/models/api/ApiRequestError';

export function reportOrRethrow(error: unknown, onError?: (error: ApiRequestError) => void): void {
	if (!onError) {
		throw error;
	}

	onError(error as ApiRequestError);
}
